module.exports = __webpack_public_path__ + "static/GorditaBlack-e7c91f321403cc1954cb73ea5fc2abcb.woff";